const LoadingModalConfig = {
    titles: {
        mainTitle: {
            width: 454,
            height: 41,
        },
        subtitle: {
            width: 318,
            height: 20,
        },
    },

    invite: {
        label: {
            width: 166,
            height: 8,
        },
        input: {
            width: 286,
            height: 36,
        },
        button: {
            width: 71,
            height: 36,
        },
    },

    rewards: {
        numberOfCards: 3,
        card: {
            innerLoaders: [
                { width: 118, height: 20 },
                { width: 52, height: 20 },
                { width: 52, height: 40 },
                { width: 118, height: 20 },
            ],
            footer: {
                width: 81,
                height: 19,
            },
        },
    },

    progressBar: {
        label: {
            width: 129,
            height: 20,
        },
        bar: {
            width: 584,
            height: 20,
        },
    },

    howItWorks: {
        label: {
            width: 95,
            height: 20,
        },
        icon: {
            width: 20,
            height: 20,
        },
    },
};

export default LoadingModalConfig;
